import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { Watermark, Tooltip } from "antd";
import { MicroAppLayout, sendGlobalMessage } from "@spiral-app/core";
import { useAppData, useOutletContext } from "@umijs/max";
import { merge } from "lodash-es";
import { closeAll } from "../utils/tabs";
import LayoutHeader from "../components/LayoutHeader";
import LayoutFooter from "../components/LayoutFooter";
import useTiMaxStore from "../hooks/useTiMaxStore";
import { getFirstPath, translateMenu } from "../utils/menu";
import { getLogo } from "../utils/logo";
const TiSpiralAppLayout = ({
  watermark = false,
  iconfontUrl,
  mainAppInfo,
  footer,
  proLayoutToken,
  onEditPassword,
  onLogout,
  renderLayoutHeader
}) => {
  var _a, _b;
  const appData = useAppData();
  const { locale, loginInfo, setMenu } = useTiMaxStore();
  const { menu, userInfo, token } = loginInfo || {};
  const { title, logo } = useOutletContext();
  useEffect(() => {
    if (!loginInfo) {
      onLogout == null ? void 0 : onLogout();
    }
    if (mainAppInfo) {
      sendGlobalMessage({
        "@@mainAppInfo": merge(
          {
            token,
            locale
          },
          mainAppInfo
        )
      });
    }
  }, [loginInfo, mainAppInfo]);
  useEffect(() => {
    if (menu) {
      translateMenu(menu, locale);
      setMenu(menu);
    }
  }, [locale]);
  const layoutConfig = {
    homePath: process.env.RUNTIME_ENV === "development" ? "/" : getFirstPath(menu == null ? void 0 : menu[0]),
    route: (_b = (_a = appData.clientRoutes[0]) == null ? void 0 : _a.routes) == null ? void 0 : _b[1],
    renderFooter: () => footer === void 0 ? /* @__PURE__ */ jsx(LayoutFooter, {}) : footer,
    proLayoutToken: proLayoutToken && (() => proLayoutToken)
  };
  const proLayoutConfig = {
    layout: "mix",
    title,
    headerTitleRender: () => /* @__PURE__ */ jsx(
      "img",
      {
        style: {
          cursor: "pointer",
          height: 30
        },
        src: logo || getLogo()
      }
    ),
    headerContentRender: () => /* @__PURE__ */ jsx(
      LayoutHeader,
      {
        title,
        onEditPassword,
        onLogout,
        renderLayoutHeader
      }
    ),
    iconfontUrl,
    onMenuHeaderClick: closeAll,
    menu: {
      request: () => Promise.resolve(menu)
    },
    menuItemRender: (itemProps, defaultDom) => {
      return /* @__PURE__ */ jsx(Tooltip, { title: itemProps.name, placement: "right", mouseEnterDelay: 1.5, children: defaultDom });
    }
  };
  const newProps = {
    proLayoutConfig,
    layoutConfig,
    appData
  };
  if (!loginInfo) {
    return null;
  }
  return watermark ? /* @__PURE__ */ jsx(
    Watermark,
    {
      font: { fontSize: 14 },
      content: userInfo && [userInfo.userName, userInfo.userAccount],
      children: /* @__PURE__ */ jsx(MicroAppLayout, { ...newProps })
    }
  ) : /* @__PURE__ */ jsx(MicroAppLayout, { ...newProps });
};
var TiSpiralAppLayout_default = TiSpiralAppLayout;
export {
  TiSpiralAppLayout_default as default
};
